import { IPublicTypeNodeData } from './node-data';

export type IPublicTypeNodeDataType = IPublicTypeNodeData | IPublicTypeNodeData[];
